import React from 'react';
import { i18n as I18n } from 'utils/i18n';
import Textbox from '../../textbox';

const PostCodeField = ({ error, ...props }) => {
  return (
    <Textbox
      label={I18n.t('registration.company_details.fields.postcode.label')}
      name="postcode"
      placeholder={I18n.t('registration.company_details.fields.postcode.label')}
      error={!!error}
      errorMsg={error}
      className="input--postcode"
      {...props}
    />
  );
};

export default PostCodeField;
